/* eslint-disable */
export default {
  419: 'America Latina',
  AR: 'Argentina',
  AT: 'Austria',
  AU: 'Australia',
  BE: 'Belgio',
  BG: 'Bulgaria',
  BH: 'Bahrein',
  BJ: 'Benin',
  BR: 'Brasile',
  CA: 'Canada',
  CH: 'Svizzera',
  CL: 'Cile',
  CN: 'Cina',
  CO: 'Colombia',
  CY: 'Cipro',
  CZ: 'Repubblica Ceca',
  DE: 'Germania',
  DK: 'Danimarca',
  DO: 'Repubblica Dominicana',
  EE: 'Estonia',
  ES: 'Spagna',
  FI: 'Finlandia',
  FR: 'Francia',
  GB: 'Regno Unito',
  GE: 'Georgia',
  GH: 'Ghana',
  GN: 'Guinea',
  GR: 'Grecia',
  HK: 'Hong Kong',
  HR: 'Croazia',
  HU: 'Ungheria',
  ID: 'Indonesia',
  IE: 'Irlanda',
  IL: 'Israele',
  IN: 'India',
  IT: 'Italia',
  JP: 'Giappone',
  KE: 'Kenya',
  KR: 'Corea del Sud',
  LT: 'Lituania',
  LU: 'Lussemburgo',
  LV: 'Lettonia',
  MX: 'Messico',
  MY: 'Malesia',
  NG: 'Nigeria',
  NL: 'Paesi Bassi',
  NO: 'Norvegia',
  NZ: 'Nuova Zelanda',
  PA: 'Panama',
  PE: 'Perù',
  PH: 'Filippine',
  PK: 'Pakistan',
  PL: 'Polonia',
  PR: 'Porto Rico',
  PT: 'Portogallo',
  RO: 'Romania',
  SE: 'Svezia',
  SG: 'Singapore',
  SI: 'Slovenia',
  SK: 'Slovacchia',
  SV: 'El Salvador',
  TR: 'Turchia',
  TW: 'Taiwan',
  UA: 'Ucraina',
  US: 'Stati Uniti',
  VN: 'Vietnam',
  ZA: 'Sudafrica',
} as const;

// @key: @#@"419"@#@ @source: @#@"Latin America"@#@
// @key: @#@"AR"@#@ @source: @#@"Argentina"@#@
// @key: @#@"AT"@#@ @source: @#@"Austria"@#@
// @key: @#@"AU"@#@ @source: @#@"Australia"@#@
// @key: @#@"BE"@#@ @source: @#@"Belgium"@#@
// @key: @#@"BG"@#@ @source: @#@"Bulgaria"@#@
// @key: @#@"BH"@#@ @source: @#@"Bahrain"@#@
// @key: @#@"BJ"@#@ @source: @#@"Benin"@#@
// @key: @#@"BR"@#@ @source: @#@"Brazil"@#@
// @key: @#@"CA"@#@ @source: @#@"Canada"@#@
// @key: @#@"CH"@#@ @source: @#@"Switzerland"@#@
// @key: @#@"CL"@#@ @source: @#@"Chile"@#@
// @key: @#@"CN"@#@ @source: @#@"China"@#@
// @key: @#@"CO"@#@ @source: @#@"Colombia"@#@
// @key: @#@"CY"@#@ @source: @#@"Cyprus"@#@
// @key: @#@"CZ"@#@ @source: @#@"Czech Republic"@#@
// @key: @#@"DE"@#@ @source: @#@"Germany"@#@
// @key: @#@"DK"@#@ @source: @#@"Denmark"@#@
// @key: @#@"DO"@#@ @source: @#@"Dominican Republic"@#@
// @key: @#@"EE"@#@ @source: @#@"Estonia"@#@
// @key: @#@"ES"@#@ @source: @#@"Spain"@#@
// @key: @#@"FI"@#@ @source: @#@"Finland"@#@
// @key: @#@"FR"@#@ @source: @#@"France"@#@
// @key: @#@"GB"@#@ @source: @#@"United Kingdom"@#@
// @key: @#@"GE"@#@ @source: @#@"Georgia"@#@
// @key: @#@"GH"@#@ @source: @#@"Ghana"@#@
// @key: @#@"GN"@#@ @source: @#@"Guinea"@#@
// @key: @#@"GR"@#@ @source: @#@"Greece"@#@
// @key: @#@"HK"@#@ @source: @#@"Hong Kong"@#@
// @key: @#@"HR"@#@ @source: @#@"Croatia"@#@
// @key: @#@"HU"@#@ @source: @#@"Hungary"@#@
// @key: @#@"ID"@#@ @source: @#@"Indonesia"@#@
// @key: @#@"IE"@#@ @source: @#@"Ireland"@#@
// @key: @#@"IL"@#@ @source: @#@"Israel"@#@
// @key: @#@"IN"@#@ @source: @#@"India"@#@
// @key: @#@"IT"@#@ @source: @#@"Italy"@#@
// @key: @#@"JP"@#@ @source: @#@"Japan"@#@
// @key: @#@"KE"@#@ @source: @#@"Kenya"@#@
// @key: @#@"KR"@#@ @source: @#@"South Korea"@#@
// @key: @#@"LT"@#@ @source: @#@"Lithuania"@#@
// @key: @#@"LU"@#@ @source: @#@"Luxembourg"@#@
// @key: @#@"LV"@#@ @source: @#@"Latvia"@#@
// @key: @#@"MX"@#@ @source: @#@"Mexico"@#@
// @key: @#@"MY"@#@ @source: @#@"Malaysia"@#@
// @key: @#@"NG"@#@ @source: @#@"Nigeria"@#@
// @key: @#@"NL"@#@ @source: @#@"Netherlands"@#@
// @key: @#@"NO"@#@ @source: @#@"Norway"@#@
// @key: @#@"NZ"@#@ @source: @#@"New Zealand"@#@
// @key: @#@"PA"@#@ @source: @#@"Panama"@#@
// @key: @#@"PE"@#@ @source: @#@"Peru"@#@
// @key: @#@"PH"@#@ @source: @#@"Philippines"@#@
// @key: @#@"PK"@#@ @source: @#@"Pakistan"@#@
// @key: @#@"PL"@#@ @source: @#@"Poland"@#@
// @key: @#@"PR"@#@ @source: @#@"Puerto Rico"@#@
// @key: @#@"PT"@#@ @source: @#@"Portugal"@#@
// @key: @#@"RO"@#@ @source: @#@"Romania"@#@
// @key: @#@"SE"@#@ @source: @#@"Sweden"@#@
// @key: @#@"SG"@#@ @source: @#@"Singapore"@#@
// @key: @#@"SI"@#@ @source: @#@"Slovenia"@#@
// @key: @#@"SK"@#@ @source: @#@"Slovakia"@#@
// @key: @#@"SV"@#@ @source: @#@"El Salvador"@#@
// @key: @#@"TR"@#@ @source: @#@"Türkiye"@#@
// @key: @#@"TW"@#@ @source: @#@"Taiwan"@#@
// @key: @#@"UA"@#@ @source: @#@"Ukraine"@#@
// @key: @#@"US"@#@ @source: @#@"United States"@#@
// @key: @#@"VN"@#@ @source: @#@"Vietnam"@#@
// @key: @#@"ZA"@#@ @source: @#@"South Africa"@#@
